import React from 'react';
import './bts.css';

export default function Bts() {
	return (
		<section className="text-bts">
			<div className="container">
				<h1>Cycle BTS - Technicien Supérieur</h1>
				<span className="iusse-description">
					L'université IUSSE a formé des Techniciens de haut niveau avec une
					solide formation.
					<br />
					<br />
					Pendant ses études, le futur technicien va acquérir de solides
					connaissances et techniques, tant au contact du monde académique que
					de l'industrie.
					<br />
					<br />
					Il apprend à mobiliser des savoirs de manière transversale face à des
					problèmes complexes. Il renforce ses compétences relationnelles et
					managériales et développe une large ouverture multiculturelle.
					<br />
					<br />
					Les étudiants, dès leur sortie de l'école, s'intègrent facilement dans
					le monde de l'entreprise à l'échelle nationale et internationale.
					<br />
					<br />
					La formation prend en compte les problématiques auxquelles seront
					confrontés les élèves dans leur futur emploi afin de « construire »
					des professionnels qui seront amenés à prendre des responsabilités au
					fur et à mesure de leur carrière.
					<br />
					<strong>NOS FILIÈRES</strong>
					<br />
					<strong>• Finances Comptabilité et Gestion des Entreprises</strong>
					<br />
					<strong>• Assistanat de Direction</strong>
					<br />
					<strong>• Électronique</strong>
					<br />
					<strong>• Optique Lunetterie</strong>
					<br />
					<strong>• Hygiène et Sécurité de travail</strong>
					<br />
					<strong>
						• Industrie Agro-Alimentaire et Chimique. Option : Contrôle qualité
					</strong>
					<br />
					<strong>• Agriculture Tropicale Option Production Animale</strong>
					<br />
					<strong>• Agriculture Tropicale. Option : production Végétale</strong>
					<br />
					<strong>• Informatique, Développeur d'Application</strong>
					<br />
					<strong>
						• Tourisme Hôtellerie - Réseaux informatiques et Télécommunication
					</strong>
					<br />
					<strong>• Génie énergétique et des ressources naturelles</strong>
					<br />
					<strong>
						• Industrie Agro-Alimentaire et Chimique option ; Production
					</strong>
					<br />
					<strong>
						• Gestion de l'Environnement et des ressources Naturelles
					</strong>
				</span>
			</div>
		</section>
	);
}
